import FrameMessenger from 'frame-messenger';
import Logger from '../utils/logger';
import ENV from '../config/env';

export default class FrameEventManager {
  constructor() {
    this.customHandlers = {};
    this.frameMessenger = new FrameMessenger(ENV.brickHost);
  }

  addFrameHandler(eventName, handler) {
    this.frameMessenger.receive(eventName, (frameName, data) => {
      Logger.debug('Received a', eventName, 'message from', frameName, 'with data:', data);

      if (this.hasEvent(eventName)) {
        Logger.debug('Calling custom event for', eventName);
        this.fireEvent(eventName, frameName, data);
      } else {
        handler(frameName, data);
      }
    });
  }

  hasEvent(eventName) {
    return this.customHandlers[eventName] && this.customHandlers[eventName].length > 0;
  }

  fireEvent(eventName, ...args) {
    const handler = this.customHandlers[eventName];

    if (handler) {
      handler.forEach((func) => {
        func(...args);
      });
    }
  }

  addEventListener(eventName, handler) {
    // This is equivalent to this.handlers.hasOwnProperty(eventName)
    if (!Object.prototype.hasOwnProperty.call(this.customHandlers, eventName)) {
      this.customHandlers[eventName] = [];
    }

    this.customHandlers[eventName].push(handler);
  }

  removeEventListener(eventName) {
    this.customHandlers[eventName] = [];
  }
}



// WEBPACK FOOTER //
// ./src/models/frame-event-manager.js